import { Head, router, useForm, usePage } from "@inertiajs/react"

import { InterviewForm } from "@/components/interviews/interview-form"
import AppLayout from "@/layouts/app-layout"
import { interviewsPath } from "@/routes"

interface FormState {
  title: string
  interviewee_name: string
  status: "published" | "draft" | "archived"
  content: string
  cover?: File | null
  cover_url?: string
}

export default function InterviewsNew() {
  const page = usePage()
  const search = page.url.includes("?") ? page.url.split("?")[1] : ""
  const params = new URLSearchParams(search)
  const from = params.get("from")

  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { data, setData, post, processing, errors, reset } = useForm<FormState>(
    {
      title: "",
      interviewee_name: "",
      status: "published",
      content: "",
      cover: null,
      cover_url: "",
    },
  )

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(interviewsPath(), {
      forceFormData: true,
      onSuccess: () => reset(),
    })
  }

  const handleCancel = () => {
    if (from) {
      router.visit(from)
    } else {
      router.visit(interviewsPath())
    }
  }

  return (
    <AppLayout>
      <Head title="Nueva entrevista" />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <InterviewForm
          title="Nueva entrevista"
          data={data}
          errors={errors as Record<string, string>}
          processing={processing}
          onChange={(partial) => {
            Object.entries(partial).forEach(([key, value]) => {
              setData(
                key as keyof FormState,
                value as FormState[keyof FormState],
              )
            })
          }}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          submitLabel="Crear entrevista"
        />
      </div>
    </AppLayout>
  )
}
